/**
 * Definition of all routes of the application.
 */
export const routes = {
  rotorTypeList: {
    url: 'rotorTypeList',
    absoluteUrl: '/rotorTypeList',
  },
  rotorTypeDetailsCreate: {
    url: 'rotorTypeDetails/create',
    absoluteUrl: '/rotorTypeDetails/create',
  },
  rotorTypeDetailsEdit: {
    url: 'rotorTypeDetails/edit',
    absoluteUrl: '/rotorTypeDetails/edit',
  },
  unhandledError: {
    url: 'serverUnhandledError',
    absoluteUrl: '/serverUnhandledError',
  },
};
